import { createAction, props } from '@ngrx/store';

import { HttpTrialAccountRequestFilters, TrialAccountRequest } from '../models';

export enum TrialAccountRequestActionTypes {
  GetRequests = '[Trial] Get Requests',
  GetRequestsSuccess = '[Trial] Get Requests Success',
  GetRequestsFailed = '[Trial] Get Requests Failed',

  RequestApprove = '[Trial] Request Approve',
  RequestApproveSuccess = '[Trial] Request Approve Success',

  RequestDecline = '[Trial] Request Decline',
  RequestDeclineSuccess = '[Trial] Request Decline Success',

  AddFilters = '[Trial] Add Filters',

  Failure = '[Trial] Failure',
}

export namespace TrialAccountRequestActions {
  export namespace GetItems {
    export const request = createAction(
      TrialAccountRequestActionTypes.GetRequests,
      props<{ httpFilters?: HttpTrialAccountRequestFilters[] }>(),
    );
    export const success = createAction(
      TrialAccountRequestActionTypes.GetRequestsSuccess,
      props<{
        items: TrialAccountRequest[];
        httpFilters?: HttpTrialAccountRequestFilters[];
      }>(),
    );
    export const failed = createAction(
      TrialAccountRequestActionTypes.GetRequestsFailed,
    );
  }

  export namespace RequestApprove {
    export const request = createAction(
      TrialAccountRequestActionTypes.RequestApprove,
      props<{ accountId: string; requestId: string; redirect?: boolean }>(),
    );
    export const success = createAction(
      TrialAccountRequestActionTypes.RequestApproveSuccess,
      props<{ requestId: string }>(),
    );
  }

  export namespace RequestDecline {
    export const request = createAction(
      TrialAccountRequestActionTypes.RequestDecline,
      props<{ requestId: string }>(),
    );

    export const success = createAction(
      TrialAccountRequestActionTypes.RequestDeclineSuccess,
      props<{ requestId: string }>(),
    );
  }

  export namespace Filters {
    export const add = createAction(
      TrialAccountRequestActionTypes.AddFilters,
      props<{ filters: HttpTrialAccountRequestFilters[] }>(),
    );
  }

  export const failure = createAction(
    TrialAccountRequestActionTypes.Failure,
    props<{ errorMessage: string }>(),
  );
}
